<template>
  <div>
    <vs-prompt
      title="Add new product"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Product name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the name of the product. It can be changed later."
                position="bottom"
              >
                <vs-input class="inputx w-full" v-model="name" />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      var result = await this.$store.dispatch("bookingProducts/create", { productName: this.name });
      this.$router.push({ name: "booking-product", params: { id: result } }).catch(() => {});

      this.$vs.notify({
        color: "green",
        title: `Product created`,
        text: "Product created",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
